// Unpublished Work © 2025 Deere & Company.

import t from 'tcomb';

export const PartneredAccounts = t.struct({
    accountId: t.Number,
    orgName: t.String

}, {
    defaultProps: {
        accountId: 0,
        orgName: ''
    },
    name: 'PartneredAccounts'
});

export const Organizations = t.struct({
    id: t.String,
    isPartnered: t.Boolean,
    name: t.String,
    partneredAccounts: t.list(PartneredAccounts)

}, {
    defaultProps: {
        id: '',
        isPartnered: false,
        name: '',
        partneredAccounts: []
    },
    name: 'Organizations'
});
